import React from "react";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";

export default function EventInsights(props: {
	eventInsights: string[] | null;
}) {
	if (!props.eventInsights || props.eventInsights.length === 0) {
		return null;
	}

	return (
		<div className="card card--raised">
			<div className="card__body card__body--spaced">
				{props.eventInsights.map((insight, index) => {
					return (
						<InfoMessageComponent
							key={index}
							size="sml"
							type="ghost"
							message={insight}
							addClassName="statistics__tip"
							customIcon="u-icon--base u-icon--betting-tip--alt"
						/>
					);
				})}
			</div>
		</div>
	);
}
